import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { NavigationRoot } from "../../models/navigation-root.model";
import { Injectable } from "@angular/core";
import { NavigationService } from "../../services/navigation.service";


@Injectable()
export class NavResolver  {

    constructor(
        public _navService: NavigationService
    ) { }

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<NavigationRoot> {
        return this._navService.getNavigation();
    }
}